import { useEffect, useRef, useState } from 'react';
import useGameContext from '~/client/components/Game/context/Game/useGameContext';
import useUserCurrency from './useUserCurrency';

const usePreferredInGameCurrency = () => {
  const { preferredInGameCurrency, walletCurrency, loading } =
    useUserCurrency();
  const [inGameCurrencyState, setInGameCurrencyState] = useState(
    preferredInGameCurrency,
  );
  const [profileCurrency, setProfileCurrency] = useState(
    preferredInGameCurrency,
  );

  const { setInGameCurrency } = useGameContext();

  useEffect(() => {
    if (isMounted.current) {
      setInGameCurrency(preferredInGameCurrency);
    }
  }, [preferredInGameCurrency, setInGameCurrency]);

  const isMounted = useRef(false);

  useEffect(() => {
    if (isMounted.current) {
      setProfileCurrency(preferredInGameCurrency);
    }
  }, [preferredInGameCurrency]);

  useEffect(() => {
    if (isMounted.current) {
      setProfileCurrency(inGameCurrencyState);
    }
  }, [inGameCurrencyState]);

  useEffect(() => {
    // eslint-disable-next-line immutable/no-mutation
    isMounted.current = true;
  }, []);

  return {
    profileCurrency,
    setCurrency: setInGameCurrencyState,
    walletCurrency,
    loading,
  };
};

export default usePreferredInGameCurrency;
